<template>
  <div class="t-stars-google flex">
    <template v-if="compact">
      <div class="flex items-center">
        <div class="t-stars-google--ratio flex">
          <template v-if="fullStars > 0">
            <UIcon
              v-for="index in fullStars"
              :key="index"
              name="i-ic-round-star"
              class="w-4 h-4 text-yellow-400"
              aria-hidden="true"
            />
          </template>

          <UIcon
            v-if="middleStar"
            name="i-ic-round-star-half"
            class="w-4 h-4 text-yellow-400"
            aria-hidden="true"
          />

          <template v-if="emptyStars > 0">
            <UIcon
              v-for="index in emptyStars"
              :key="index"
              name="i-ic-round-star-border"
              class="w-4 h-4 text-gray-600"
              aria-hidden="true"
            />
          </template>
        </div>
        <TText
          v-if="comments"
          color="text-gray-600"
          clamp="clamp1"
          classes="mb-0 ml-1 mr-2"
        >
          ({{ comments }})
        </TText>
        <UIcon name="i-logos-google" aria-hidden="true" />
      </div>
    </template>
    <template v-else>
      <div class="t-stars-google--ratio flex">
        <template v-if="fullStars > 0">
          <UIcon
            v-for="index in fullStars"
            :key="index"
            name="i-ic-round-star"
            class="w-4 h-4 text-yellow-400"
            aria-hidden="true"
          />
        </template>

        <UIcon
          v-if="middleStar"
          name="i-ic-round-star-half"
          class="w-4 h-4 text-yellow-400"
          aria-hidden="true"
        />

        <template v-if="emptyStars > 0">
          <UIcon
            v-for="index in emptyStars"
            :key="index"
            name="i-ic-round-star-border"
            class="w-4 h-4 text-gray-600"
            aria-hidden="true"
          />
        </template>
      </div>
      <div
        v-if="comments"
        class="t-stars--comments text-xs text-gray-500 flex content-center leading-4 ml-1"
      >
        ({{ comments }})
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
interface Props {
  stars: number
  maximumStars?: number
  stepDown?: number
  stepUp?: number
  comments?: number | null
  compact?: boolean
  translations?: {
    comments?: string
  }
}

const props = withDefaults(defineProps<Props>(), {
  maximumStars: 5,
  stepDown: 0.25,
  stepUp: 0.75,
  comments: 0,
  compact: false,
})

const roundStars = (
  stars: number,
  maximumStars: number,
  stepDown: number,
  stepUp: number,
): {
  fullStars: number
  middleStar: boolean
  emptyStars: number
} => {
  let fullStars: number = Math.floor(stars)
  let emptyStars: number = maximumStars - fullStars
  let middleStar: boolean = false

  const num = stars
  const rem = num % 1

  // half star
  if (rem >= stepDown && rem < stepUp) {
    middleStar = true
    emptyStars = emptyStars - 1
  }
  // round up
  else if (rem >= stepUp) {
    fullStars = fullStars + 1
    emptyStars = maximumStars - fullStars
  }

  return {
    fullStars,
    middleStar,
    emptyStars,
  }
}

const { fullStars, middleStar, emptyStars } = roundStars(
  props.stars,
  props.maximumStars,
  props.stepDown,
  props.stepUp,
)
</script>
